import React, {Children} from 'react';

export default function FormSection({children, first, last, double}) {
    const formSectionClassName = 'checkout-form-section';
    const positionClass = getPositionClass(first, last);
    const doubleClass = double ? '-double' : '';
    const classes = `${formSectionClassName} ${positionClass} ${doubleClass}`;
    const amountFields = Children.toArray(children).length;
    const isSingleChild = amountFields === 1;
    return (
        <div className={classes}>
            {isSingleChild
                ? children
                : children.map((field, index) => {
                      const isFirst = index === 0;
                      const isLast = index + 1 === amountFields;
                      let classes = ['checkout-form-section__field'];
                      isFirst && classes.push('-first');
                      isLast && classes.push('-last');
                      return React.cloneElement(field, {...field.props, key: index, classes: classes.join(' ')});
                  })}
        </div>
    );
}

function getPositionClass(first, last) {
    if (first) {
        return '-first';
    }
    if (last) {
        return '-last';
    }
    return '';
}
